// extracted by mini-css-extract-plugin
export var footer = "_mb-0";
export var inherit = "_mb-1";
export var input = "_mb-2";
export var modalContent = "_mb-3";
export var quillEditor = "_mb-4";
export var subtitle = "_mb-5";